import { render, staticRenderFns } from "./ZohoIcon.vue?vue&type=template&id=52ed333a&scoped=true"
import script from "./ZohoIcon.vue?vue&type=script&lang=js"
export * from "./ZohoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ed333a",
  null
  
)

export default component.exports